import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import moment from 'moment'

Vue.config.productionTip = false
//convert date
Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY hh:mm')
  }
});


new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
